import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { neutral } from '../../../styles/mui/colors';
import useScreenSize from '../../../util/hooks/useScreenSize';
import IconFilter from '../../Icons/IconFilter';

const SearchFiltersPrimary = ({
  children,
  sortByComponent = null,
  listingsAreLoaded,
  resultsCount = null,
  perPage = 0,
  isSecondaryFiltersOpen = false,
  toggleSecondaryFiltersOpen = null,
  selectedSecondaryFiltersCount = 0,
  mapToggleComponent,
}) => {
  const intl = useIntl();
  const { isMobile } = useScreenSize();
  // const hasNoResult = listingsAreLoaded && resultsCount === 0;

  const toggleSecondaryFiltersOpenButton = toggleSecondaryFiltersOpen ? (
    !isMobile ? (
      <Button
        onClick={() => toggleSecondaryFiltersOpen(!isSecondaryFiltersOpen)}
        startIcon={<IconFilter />}
        sx={{
          borderRadius: 200,
          bgcolor: 'white',
          borderColor: neutral[200],
          '&:hover': {
            bgcolor: 'white',
          },
          '&:active': {
            bgcolor: 'white',
          },
          '&:focus': {
            bgcolor: 'white',
          },
          '& .MuiButton-startIcon': {
            color: 'inherit',
          },
          color: 'inherit',
        }}
        variant="outlined"
      >
        <Typography component="h3" variant="body2">
          <FormattedMessage
            id="SearchFiltersPrimary.moreFiltersButton"
            values={{ count: selectedSecondaryFiltersCount }}
          />
        </Typography>
      </Button>
    ) : null
  ) : null;

  const perPageLabel =
    resultsCount && resultsCount > perPage
      ? intl.formatMessage(
        {
          id: 'SearchFiltersPrimary.perPage',
        },
        { perPage: perPage },
      )
      : '';

  const resultsIndicator = !isMobile ? (
    <Box sx={{ mr: 2 }}>
      <Typography component="h2" variant="body1">
        <FormattedMessage
          id="SearchFiltersPrimary.foundResults"
          values={{ count: resultsCount, perPage: perPageLabel }}
        />
      </Typography>
    </Box>
  ) : null;

  return (
    <Box sx={{ my: 1 }}>
      <Stack spacing={1}>
        <Box id="test" sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, flexWrap: 'wrap' }}>
          {sortByComponent}
          {mapToggleComponent}
          {children}
          {toggleSecondaryFiltersOpenButton}
        </Box>
        {listingsAreLoaded ? (
          resultsIndicator
        ) : (
          <Skeleton sx={{ width: 180, height: 32 }} variant="rounded" />
        )}
      </Stack>
    </Box>
  );
};


export default SearchFiltersPrimary;
